import { render, staticRenderFns } from "./NoteThread.vue?vue&type=template&id=01aaaae8"
import script from "./NoteThread.vue?vue&type=script&lang=js"
export * from "./NoteThread.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Notes: require('/home/runner/_work/plannr-nuxt/plannr-nuxt/components/Notes.vue').default,NoteRedactorInput: require('/home/runner/_work/plannr-nuxt/plannr-nuxt/components/NoteRedactorInput.vue').default})
